const prefersReducedMotion = () => {
  if (!window.matchMedia) {
    return false
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

const setButtonState = (button, isPaused) => {
  const label = isPaused ? 'Play background video' : 'Pause background video'

  button.classList.toggle('is-paused', isPaused)
  button.classList.toggle('is-playing', !isPaused)
  button.setAttribute('aria-label', label)
  button.setAttribute('aria-pressed', isPaused ? 'true' : 'false')

  const labelNode = button.querySelector('.sr-only')
  if (labelNode) {
    labelNode.textContent = label
  }
}

export function handleBackgroundVideoControls() {
  const videoWraps = document.querySelectorAll('.bg-video-wrap')

  Array.prototype.forEach.call(videoWraps, (wrap) => {
    const video = wrap.querySelector('video')
    const button = wrap.querySelector('.background-video-toggle')

    if (!video || !button) {
      return
    }

    const syncState = () => {
      setButtonState(button, video.paused)
    }

    video.addEventListener('play', syncState)
    video.addEventListener('pause', syncState)
    video.addEventListener('ended', syncState)

    button.addEventListener('click', () => {
      if (video.paused) {
        const playPromise = video.play()

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(syncState)
        }
      } else {
        video.pause()
      }
    })

    if (!prefersReducedMotion()) {
      const playPromise = video.play()

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(syncState)
      }
    }

    syncState()
  })
}



// WEBPACK FOOTER //
// ./scripts/func/backgroundVideo.js